var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui_radio",class:{ on: !!_vm.value, disabled: _vm.disabled, readonly: _vm.readonly, filled: _vm.filled },on:{"click":_vm.onClick}},[_c('i',{staticClass:"icon icon--radio"}),_c('span',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }